// API client pour les communes
export interface Commune {
  id: number;
  name: string;
  wilaya_code: string;
  wilaya_name: string;
  display_name?: string;
}

class CommuneAPI {
  private baseUrl = `${import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api'}/communes`;

  async getAll(filters?: {
    wilaya_code?: string;
    search?: string;
    limit?: number;
  }) {
    const params = new URLSearchParams();
    if (filters?.wilaya_code) params.append('wilaya_code', filters.wilaya_code);
    if (filters?.search) params.append('search', filters.search);
    if (filters?.limit) params.append('limit', filters.limit.toString());

    const url = params.toString() ? `${this.baseUrl}?${params}` : this.baseUrl;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch communes');
    return response.json();
  }

  async getByWilaya(wilayaCode: string): Promise<Commune[]> {
    const response = await fetch(`${this.baseUrl}/wilaya/${wilayaCode}`);
    if (!response.ok) throw new Error('Failed to fetch communes by wilaya');
    return response.json();
  }

  async search(term: string, limit: number = 20): Promise<Commune[]> {
    const response = await fetch(`${this.baseUrl}/search/${encodeURIComponent(term)}?limit=${limit}`);
    if (!response.ok) throw new Error('Failed to search communes');
    return response.json();
  }
}

export const communeAPI = new CommuneAPI();